"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.badgePosition = exports.badgeSize = exports.badgeType = void 0;
exports.badgeType = {
    primary: 'primary',
    secondary: 'secondary',
};
exports.badgeSize = {
    small: 'small',
    medium: 'medium',
    /** @deprecated */
    big: 'big',
};
exports.badgePosition = {
    /** @deprecated */
    topLeft: 'tl',
    /** @deprecated */
    topRight: 'tr',
    /** @deprecated */
    bottomLeft: 'bl',
    /** @deprecated */
    bottomRight: 'br',
    'top-start': 'top-start',
    'top-end': 'top-end',
    'bottom-start': 'bottom-start',
    'bottom-end': 'bottom-end',
};
